import { render, staticRenderFns } from "./FormSelectItem.vue?vue&type=template&id=ad0151b2&"
import script from "./FormSelectItem.vue?vue&type=script&lang=js&"
export * from "./FormSelectItem.vue?vue&type=script&lang=js&"
import style0 from "./FormSelectItem.vue?vue&type=style&index=0&id=ad0151b2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports